export const FILTERED_DOCUMENT_ID = 'LB2'
export const LIST_OF_CLASS_NAMES = ['form__input', 'hide-S', 'form__buttons', 'tooltip']
